__turbopack_context__.v({
  "emptyDescription": "WarehousesList-module-scss-module__FB1LHq__emptyDescription",
  "emptyState": "WarehousesList-module-scss-module__FB1LHq__emptyState",
  "emptyStateContent": "WarehousesList-module-scss-module__FB1LHq__emptyStateContent",
  "emptyTitle": "WarehousesList-module-scss-module__FB1LHq__emptyTitle",
  "headerWrapper": "WarehousesList-module-scss-module__FB1LHq__headerWrapper",
  "loadingSpinner": "WarehousesList-module-scss-module__FB1LHq__loadingSpinner",
  "loadingWrapper": "WarehousesList-module-scss-module__FB1LHq__loadingWrapper",
  "modalTitle": "WarehousesList-module-scss-module__FB1LHq__modalTitle",
  "nearHeaderWrapper": "WarehousesList-module-scss-module__FB1LHq__nearHeaderWrapper",
  "results": "WarehousesList-module-scss-module__FB1LHq__results",
  "warehouseModal": "WarehousesList-module-scss-module__FB1LHq__warehouseModal",
  "warehouseScrollTarget": "WarehousesList-module-scss-module__FB1LHq__warehouseScrollTarget",
});
